import { h } from 'preact';
import * as BaseComp from 'components/bolt/toutHorizontal/toutHorizontal.js';

import s from 'components/bolt/toutHorizontal/toutHorizontal.sss';

export default class ToutHorizontal extends BaseComp.default {

	constructor(props) {
		super(props);

		this.state = {
			...this.state,
			infiniteScroll: false,
			mobileToutCount: Infinity,
			desktopToutCount: Infinity,
		};
	}

	snapToClosestTout() {
		return;
	}

	renderTitle() {
		return (
			<div class={s.header}>
				<div class={s.text}>
					{super.renderTitle()}
					{super.renderDescription()}
				</div>
				{this.renderArrows()}
			</div>
		);
	}

	renderDescription() {
		return;
	}
}
